import Animation from "./Animation";
import Barba from 'barba.js'

export default class HomepageThemeOut extends Animation {

    /**
     * The name with which the class is registered in
     * the global AnimationManager singleton.
     *
     * @returns {string}
     */
    static key() {
        return 'homepageThemeOut'
    }

    constructor() {
        super( false );
        this.setupElements();
        this.build()
    }

    /**
     * Assign all the needed elements to its respective variables
     */
    setupElements() {
        if( ! Barba.Pjax.lastLink ) throw new TypeError('Barba.lastLink is not defined. Please check you call stack');

        this.element = Barba.Pjax.lastLink;
        let theme = this.element.classList.value.replace('theme-cta ', '');
        this.container = document.querySelector('#intro-video');
        this.content = document.querySelector('.intro-content');
        this.ctas = document.querySelectorAll(`.theme-ctas .theme-cta:not(.${theme})`);
        this.header = document.querySelector('.intro-header');
    }

    /**
     * Clear the timeline, reassign variables with their respective
     * new created elements.
     *
     * @returns {HomepageThemeOut}
     */
    clear() {
        this.timeline.clear();
        this.setupElements();
        this.build();
        return this
    }

    onCompleteCallback( callback, scope = null ) {
        this.timeline.eventCallback( 'onComplete', callback, ["{self}", this], scope );
        return this;
    }

    build() {
        this.timeline
            .to( window, .2, { scrollTo: 0 } )
            .call( () => {
                document.querySelector('html').classList.add('scroll-blocked')
            } )
            .to( this.content.querySelector('p'), .5, { opacity: 0, x: -50}, 0 )
            .to( this.content.querySelector('.scroll-indicator'), .5, { opacity: 0, y: 50}, 0 )
            .addLabel('bottom')
            .staggerTo( this.ctas, .4, { opacity: 0, y: 100, x: -50, rotate: -68 }, .1, 'bottom')
            .to( this.container, .75, { css: { transform: "perspective(2000px) rotateX(90deg)" } }, "bottom"  );
            if( matchMedia('( max-width: 1025px )').matches ) {
                this.timeline.to( this.content.querySelector('.mobile .title'), .75, { css: { opacity: 0, y: -50 } }, "bottom" )
            } else {
                this.timeline.to( this.content.querySelector('.desktop .title'), .75, { css: { transform: "perspective(2000px) rotateY(-90deg)" } }, "bottom" )
            }
        this.timeline.addLabel('video')
            .to( this.header, .35, { opacity: 0, y: -50 }, 'video' )
            if( matchMedia('( max-width: 768px )').matches ) {
                this.timeline.to(this.element, .5, {css: {transform: "rotate(0)", left: 0, bottom: 0}})
            } else {
                this.timeline.to(this.element, .5, {css: {transform: "rotate(0)"}})
            }
        this.timeline.to( this.element.querySelector('.cta-content'), .1, { opacity: 0 } )
            .to( this.element.querySelector('.background'), .35, { width: '100vw' } )
            .addLabel('transition')
            .set( this.element.querySelector('.background'), { css: { transition: 'none' } } )
            .to( this.element.parentElement, .35, { height: '100%' }, 'transition' )
            .to( this.ctas, .15, { css: { height: 0, marginBottom: 0 } }, 'transition' )
            .to( this.element.querySelector('.background'), .35, { css: { top: 0, height: '100vh', transform: 'translateY(0)' } }, 'transition' )
    }
}